export default {
    token() {
        return localStorage.getItem('token');
    },
    setToken(token) {
        return localStorage.setItem('token', token);
    },
    loggedIn() {
        return this.token() !== null;
    },
};



// WEBPACK FOOTER //
// ./src/auth.js